import { Stack } from '@cmg/design-system';
import type { PropsWithChildren } from 'react';
import React from 'react';

/**
 * No tile behind the marks — a translucent disc on a translucent panel muddied both. The height is
 * fixed so the row does not change height with the publisher, but the width is not: a box wider
 * than its mark pads one side of the connector more than the other.
 *
 * Marks all ink the same amount now, but their boxes still differ — the globe's is the tallest, at
 * `MARK_INK` over the ratio MUI's icons ink at — so the height is set to clear that one.
 */
export const Mark: React.FC<PropsWithChildren> = ({ children }) => (
  <Stack height={56} alignItems="center" justifyContent="center">
    {children}
  </Stack>
);

export default Mark;
